<div class="hints-popup">
    <shared-badge (click)="onIndicatorClick($event)" class="hints-popup__badge" [disabled]="disabled" [type]="type"
        [size]="size" [isAnimating]="isAnimating" [inverted]="inverted">{{icon}}</shared-badge>
    <div class="hints-popup__bd -position-{{position}} -type-{{type}}" [ngClass]="{'-font-bold': boldText}"
        (click)="onBodyClick($event)" *ngIf="isOpen">
        <ng-content></ng-content> applied
    </div>
</div>